var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMac(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_23_1",
    "data-name": "Component 23 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1033",
    "data-name": "Ellipse 1033",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(431 389)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_10",
    "data-name": "Mask Group 10",
    transform: "translate(-431 -389)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nt-apple-fill",
    transform: "translate(431 389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8905",
    "data-name": "Path 8905",
    d: "M0,0H70V70H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8906",
    "data-name": "Path 8906",
    d: "M33.9,21.064c-2.555,0-6.51-2.9-10.675-2.8a15.762,15.762,0,0,0-13.37,8.12c-5.7,9.9-1.47,24.535,4.095,32.585,2.73,3.92,5.95,8.33,10.22,8.19,4.095-.175,5.635-2.66,10.6-2.66,4.935,0,6.335,2.66,10.675,2.555,4.41-.07,7.21-3.99,9.905-7.945a35.176,35.176,0,0,0,4.48-9.205,14.278,14.278,0,0,1-8.68-13.09c-.07-8.19,6.685-12.11,7-12.285a15.151,15.151,0,0,0-11.83-6.4c-5.39-.42-9.9,2.94-12.425,2.94ZM43,12.8a14.149,14.149,0,0,0,3.36-10.325,14.553,14.553,0,0,0-9.52,4.9c-2.1,2.415-3.92,6.3-3.43,10.01,3.605.28,7.315-1.855,9.59-4.585Z",
    fill: "#052f35 "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMac);
export default __webpack_public_path__ + "static/media/mac.199b6db5.svg";
export { ForwardRef as ReactComponent };